angular.module('impactx.productstock').controller('ProductStockListController', ProductStockListController);

ProductStockListController.$inject = ['$scope', '$routeParams', 'dataGen', 'selectedListItems', '$mdDialog', 'DownloadService'];

function ProductStockListController($scope, $routeParams, dataGen, selectedListItems, $mdDialog, DownloadService)
{
    var ctrl = this;

    this.downloadQRCode = function() {
        DownloadService.openDownloadPost('/product/qrcode/addtobasket', {paramName: "id", paramValue: selectedListItems.getFirstSelectedId()});
    };

    ctrl.editstock = function () {
        var tempScope = {};
        dataGen.getData(tempScope, {ids: selectedListItems.getSelectedIds()}, "/productstock/view").then(function () {
            $mdDialog.show({
                templateUrl: "modules/productstock/templates/editproductstock.tmpl.html",
                controller: "EditProductStockController",
                controllerAs: "editProductStockController",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    data: tempScope.data,
                    trns: tempScope.trns
                }
            });
        });
    };

    var buttonDefinition = [
        {label: "editstock", action: ctrl.editstock, condition: selectedListItems.isMultiSelection, process: 'ManageStockAmounts'},
        {label: "qrcode", action: ctrl.downloadQRCode, condition: selectedListItems.isSingleSelection, process: 'Catalog'}
    ];

    this.meta = {
        rowTemplate: 'modules/productstock/templates/productstocklist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/productstock/list',
        ctrl: this,
        id: "productstock",
        params: {'catId': $routeParams.id},
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function() {
        return this.meta;
    };
}